import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

import { SupportedThemesT, Theme } from './services/theme-utils.service';

export const RECRUITEE_THEME_LS_KEY = 'recruitee-theme';
export const RECRUITEE_THEME_MIGRATED_LS_KEY = 'recruitee-theme-migrated';
export const RECRUITEE_THEME_DEFAULT = 'light';

type BackgroundSpecificTokenExtract<T> = Extract<T, `colorBg${string}`>;
export type BackgroundToken = BackgroundSpecificTokenExtract<keyof Theme>;

type EffectiveTheme = { effectiveThemeName$: Observable<SupportedThemesT> };

export const EffectiveTheme = new InjectionToken<EffectiveTheme>(
  'effectiveThemeName$ with dark or light string',
);

export const { provide: providerEffectiveThemeFactory, inject: injectEffectiveThemeFactory } =
  createProviderToken<EffectiveTheme>('effectiveThemeName$ with dark or light string')();
